import { createAction } from '@reduxjs/toolkit';
import type { BoundaryStatsItem } from './stats.state';

export const addOrUpdateBoundaryStatsItems = createAction(
  'STATS_BOUNDARY_ADD_OR_UPDATE_ITEMS',
  (items: ReadonlyArray<BoundaryStatsItem>) => ({
    payload: {
      items,
    },
  })
);

export const requestBoundaryStatsItemsByIdIfExist = createAction(
  'STATS_BOUNDARY_REQUEST_ITEMS_BY_ID',
  (ids: ReadonlyArray<number>) => ({
    payload: {
      ids,
    },
  })
);

export const setHighlightStatsBoundaryGroup = createAction(
  'STATS_HIGHLIGHT_SET_BOUNDARY',
  (boundaryGroupId: number | null) => ({
    payload: {
      boundaryGroupId,
    },
  })
);
